<template>
<div>
    <div id="ventilation" class="wrapper">
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 換気 -->
        <app-error-list />
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="換気">1</parts-arrow>
                <span>換気設備の方式を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="換気設備の方式"
                class="flex_column"
                name="vn_houshiki"
                @click="guideTransition"
            >
                <div
                    v-for="(name, value) in master.vn_houshiki"
                    :key="'vn_houshiki' + value"
                >
                    <app-radio
                        v-model="vn_houshiki"
                        :value="value"
                        unit=""
                    >
                        {{name}}
                    </app-radio>
                    <hr class="no_border" v-if="value == '2'">
                </div>
            </app-box>
        </app-section>
    
        <!-- ダクト式の場合 -->
        <div v-if="vn_houshiki == '1' || vn_houshiki == '2'">
            <app-section>
                <h3 slot="h3">
                    <parts-arrow category="換気">2</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「ダクト式換気設備」を選択した場合、換気設備の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="比消費電力の入力"
                    class="flex_column"
                    name="vn_duct_houhou"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.vn_duct_houhou"
                        v-model="vn_duct_houhou"
                        :value="value"
                        unit=""
                        :key="'vn_duct_houhou' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="vn_duct_houhou == '2'"
                    :available="true"
                    label="省エネルギー手法"
                    class="flex_column"
                    @click="guideTransition"
                    name="vn_duct_method"
                >
                    <app-radio
                        v-for="(name, value) in master.vn_duct_method"
                        v-model="vn_duct_method"
                        :value="value"
                        unit=""
                        :key="'vn_duct_method' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="vn_duct_houhou == '3'"
                    :available="true"
                    label="比消費電力"
                    class="flex_column"
                    name="vn_other_houhou_2"
                    @click="guideTransition"
                >
                    <app-text
                        label=""
                        unit="W/(m3/h)"
                        v-model="vn_duct_hishohidenryoku"
                        class=""
                        subscript="(小数点以下2桁)"
                        sttep="0.01"
                    />
                </app-box>
            </app-section>
        </div>
    
    
        <!-- 壁付け式の場合 -->
        <div v-if="vn_houshiki == '3' || vn_houshiki == '4'">
            <app-section>
                <h3 slot="h3">
                    <parts-arrow category="換気">2</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「壁付け換気設備」を選択した場合、換気設備の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="比消費電力の入力"
                    class="flex_column"
                    name="vn_other_houhou"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.vn_other_houhou"
                        v-model="vn_other_houhou"
                        :value="value"
                        unit=""
                        :key="'vn_other_houhou' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                
                    <app-box
                        v-if="vn_other_houhou == '2'"
                        :available="true"
                        label="比消費電力"
                        class="flex_column"
                        name="vn_other_houhou_2"
                        @click="guideTransition"
                    >
                        <app-text
                            label=""
                            unit="W/(m3/h)"
                            v-model="vn_other_hishohidenryoku"
                            class=""
                            subscript="(小数点以下2桁)"
                            :step="0.01"
                        />
                    </app-box>
                
            </app-section>
        </div>
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="換気">3</parts-arrow>
                <span>換気回数を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="換気回数"
                class="flex_column"
                name="vn_freq"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.vn_freq"
                    v-model="vn_freq"
                    :value="value"
                    unit=""
                    :key="'vn_freq' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>
    
        <!-- 第一種換気設備の場合 -->
        <div v-if="vn_houshiki == '1' || vn_houshiki == '3'">
            <app-section>
                <h3 slot="h3">
                    <parts-arrow category="換気">4</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「第一種換気設備」を選択した場合、有効換気量率を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="第一種換気設備の有効換気量率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="vn_e_input"
                >
                    <app-radio
                        v-for="(name, value) in master.vn_e_input"
                        v-model="vn_e_input"
                        :value="value"
                        class="white_space"
                        unit=""
                        :key="'vn_e_input' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <div v-if="vn_e_input=='2'">
                    <app-box
                        :available="true"
                        label="第一種換気設備の有効換気量率"
                        class="flex_column"
                        name="vn_e"
                        @click="guideTransition"
                    >
                        <app-text
                            label=""
                            unit=""
                            v-model="vn_e"
                            class=""
                            subscript="(小数点以下2桁)"
                            :step="0.01"
                        />
                    </app-box>
                </div>
            </app-section>
        </div>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版換気情報入力画面
 * 
 * [算出プロパティ]
 * 詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageManualVentilation",
    data: () => ({
        //test
        hogeHoge: "0",
    }),
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'vn_houshiki',
            'vn_duct_houhou',
            'vn_duct_method',
            'vn_duct_hishohidenryoku',
            'vn_other_houhou',
            'vn_other_hishohidenryoku',
            'vn_freq',
            'vn_e',
            'vn_e_input'
        ])
    },
    mixins:[help, master],
    methods:{
        ...mapActions('data', ['update']),
    }
}
</script>

<style scoped>
.no_border{
    border:0px solid rgba(255,255,255,0);
}
.white_space{
    white-space:pre-wrap;
}
</style>

